module.exports = __webpack_public_path__ + "img/temp_profile.4f80949f.png";